import React, { useMemo } from "react";

import Radio from "antd/es/radio";
import { useIntl } from "react-intl";

import EntityType from "@mapmycustomers/shared/enum/EntityType";

import RadioGroup from "@app/component/input/RadioGroup";
import { getEntityTypeDisplayName } from "@app/util/ui";

import styles from "./EntityTypeSelector.module.scss";

interface Props {
  entityTypes: EntityType[];
  onChange: (type: EntityType) => void;
  title?: string;
  value: EntityType;
}

const EntityTypeSelector: React.FC<Props> = ({ entityTypes, onChange, title, value }) => {
  const intl = useIntl();

  const formattedEntityTypes = useMemo(
    () =>
      [EntityType.COMPANY, EntityType.PERSON, EntityType.DEAL].filter((type) =>
        entityTypes.includes(type)
      ),
    [entityTypes]
  );

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {title ??
          intl.formatMessage({
            id: "view.selectBar.addRemove.entityType.title",
            defaultMessage: "Choose which record type to use for this action",
            description: "Entity selector label on bulk editing",
          })}
      </div>
      <RadioGroup onChange={onChange} value={value}>
        {formattedEntityTypes.map((entityType) => (
          <Radio.Button key={entityType} value={entityType}>
            {getEntityTypeDisplayName(intl, entityType, { lowercase: false, plural: true })}
          </Radio.Button>
        ))}
      </RadioGroup>
    </div>
  );
};

export default EntityTypeSelector;
